import { Previous } from "./components/previous/previous";
import { Steps } from "./components/steps/steps";
import { Base } from "./navigation.base";

export const Navigation = Object.assign(Base, {
    Steps: Steps,
    Previous: Previous
});
